export default "@media (min-width: 992px) {\n  .members-table th,\n.invitations-table th {\n    width: 33%;\n  }\n}\n\n.status-table th {\n  width: 50%;\n}";